<cdx-slotted-modal verticalPadding="none" padding="none" (close)="close()">
	<h1 modal-header i18n="@@shareModal-title">Share: {{ title }}</h1>
	<div modal-content class="shareButtons">
		<a
			class="shareButtons-link"
			role="button"
			*ngFor="let link of shareLinks"
			[shareButton]="link.type"
			[title]="title"
			(click)="handleShareLinkClick(link)"
		>
			<cdx-svg-icon start [attr.name]="link.type" [name]="link.type" fill="currentColor"></cdx-svg-icon>
			<strong>{{ link.text }}</strong>
		</a>
	</div>
</cdx-slotted-modal>
